import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

import { useAuth } from "@/_zustand/auth";

// CA-7/CA-10: escucha el CustomEvent que ApiCore._forzarLogoutSesion emite
// (una sola vez por fallo de refresh, ver ApiCore.js) cuando la renovación de
// la sesión de un usuario real falla. Se monta una única vez, junto a
// useCheckToken, en src/routers/Routers.jsx.
//
// PA-11 (pregunta abierta sin resolver, ver docs/specs/migracion-login-jwt.md):
// esto navega a /login de forma literal incluso si el usuario está en medio
// de un pago (/pay-detail, /order, /mp-return) — es el comportamiento CA-10
// tal cual está escrito, no la excepción sugerida en el plan (que requiere OK
// de producto). Deuda conocida, documentada en el reporte de cierre.
export const useSesionExpirada = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const clearuserAuth = useAuth((state) => state.clearuserAuth);
  const manejandoRef = useRef(false);

  useEffect(() => {
    const onSesionExpirada = () => {
      if (manejandoRef.current) return;
      manejandoRef.current = true;

      try {
        clearuserAuth();
        // Fuerza que la siguiente request lleve un token invitado fresco
        // (CA-7): invalida la query de useCheckToken para que refetchee.
        queryClient.invalidateQueries({ queryKey: ["token"] });
        toast.error("Tu sesión expiró. Vuelve a iniciar sesión.");
        navigate("/login");
      } finally {
        manejandoRef.current = false;
      }
    };

    window.addEventListener("sima:sesion-expirada", onSesionExpirada);
    return () => window.removeEventListener("sima:sesion-expirada", onSesionExpirada);
  }, [navigate, queryClient, clearuserAuth]);
};
